exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#register .help {\n  margin: 10px;\n  margin-bottom: 0;\n}\n", ""]);

// exports
